import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { ErrorStore, Notification } from '@sleipai/sleip-models';

import {
  selectAllActiveRecordingNotificationsAdapter,
  selectActiveRecordingNotificationEntitiesAdapter,
  ActiveRecordingNotificationState,
} from '../entity/active-recording-notification.entity';
import { notificationsFeatureKey, State } from '../reducers/notification.reducer';

export const selectNotificationsState =
  createFeatureSelector<State>(notificationsFeatureKey);

export const isLoading = (state: State): boolean => state.loading;
export const isLoaded = (state: State): boolean => state.loaded;
export const isMarkingRead = (state: State): boolean => state.markingRead;
export const notificationsError = (state: State): ErrorStore | null =>
  state.error;
export const watchedRecordingId = (state: State): string | null =>
  state.watchedRecordingId;
export const activeRecordingNotificationsSlice = (
  state: State
): ActiveRecordingNotificationState => state.activeRecordingNotifications;

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectNotificationsState,
  isLoading
);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectNotificationsState,
  isLoaded
);

export const selectIsMarkingRead: MemoizedSelector<object, boolean> =
  createSelector(selectNotificationsState, isMarkingRead);

export const selectNotificationsError: MemoizedSelector<
  object,
  ErrorStore | null
> = createSelector(selectNotificationsState, notificationsError);

export const selectWatchedRecordingId: MemoizedSelector<object, string | null> =
  createSelector(selectNotificationsState, watchedRecordingId);

const selectActiveRecordingNotificationsSlice = createSelector(
  selectNotificationsState,
  activeRecordingNotificationsSlice
);

export const selectActiveRecordingNotificationEntities = createSelector(
  selectActiveRecordingNotificationsSlice,
  selectActiveRecordingNotificationEntitiesAdapter
);

export const selectAllActiveRecordingNotifications: MemoizedSelector<
  object,
  Notification[]
> = createSelector(
  selectActiveRecordingNotificationsSlice,
  selectAllActiveRecordingNotificationsAdapter
);

export const selectActiveRecordingReadContext = createSelector(
  selectWatchedRecordingId,
  selectIsLoading,
  selectActiveRecordingNotificationEntities,
  (watchedRecordingId, loading, entities) => ({
    watchedRecordingId,
    loading,
    entities,
  })
);
